export default {
    unlock: 'hordeClassUndead',
    icon: 'mdi-emoticon-dead',
    baseStats: {
        attack: 1.8,
        health: 60
    },
    exp: {
        base: 8400,
        increment: 1.7
    },
    skills: {},
    skillTree: [
        {isInnate: true, level: 0, items: []},
    ],
    quests: {
        stat: [],
        zone: [],
        level: [],
        boss: []
    }
}
